import { useQuery } from '@tanstack/react-query';

import { useSelectedStore } from '@/hooks';
import { useEcomStoreSelector } from '@/data';
import { buildSearchBodyFromParams, useSearchService } from '@/opensearch';
import { getProductsFromOpenSearchResponse } from 'utils/opensearch';
import { useFulFillmentType } from '@/hooks/useFulFillmentType';

export const useSearchProductsByTerm = (searchTerm: string) => {
  const { store } = useSelectedStore();
  const { fulfillmentType } = useFulFillmentType();
  const { customer_type, provider_inventory_location_id } =
    useEcomStoreSelector(['customer_type', 'provider_inventory_location_id']);
  const { search } = useSearchService();

  const dispensaryName = store?.short_name ?? '';
  const queryKey = [
    dispensaryName,
    customer_type,
    'products-by-seo-name',
    searchTerm,
    provider_inventory_location_id,
    fulfillmentType,
  ];

  const { data, isLoading, error, isError } = useQuery({
    queryKey,
    queryFn: async () => {
      const { searchBody } = buildSearchBodyFromParams({
        limit: 10,
        searchParams: {
          query: searchTerm,
        },
        filters: {
          isAboveThreshold: [true],
          isHideFromMenu: [false],
        },
        omitAggs: true,
      });

      const result = await search({ searchBody });
      const products = getProductsFromOpenSearchResponse({
        result,
        fulfillmentType,
        isSearchingApplied: !!searchTerm,
      });

      return { products };
    },
  });

  return { isLoading, error, isError, products: data?.products ?? [] };
};
